<template>
    <div class="row justify-content-center">
        <div class="col-md-2"></div> 
        <div class="col-md-4">
            <div class="form-group mb-2">
                <small class="input-title">Estado</small>
                <v-select v-model="data.enabled"
                    :items="states"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.enabled ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.enabled" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group mb-2">
                <small class="input-title">Verificado</small>
                <v-select v-model="data.verified"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.verified ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.verified" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-2"></div> 
        <div class="col-md-8">
            <div class="form-group mb-2">
                <small class="input-title">Protegido</small>
                <v-select v-model="data.protected"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.protected ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.protected" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-8 my-3">
            <h1 class="text-sm">Cambiar la contraseña</h1>
        </div>
        <div class="col-md-8">
            <div class="form-group mb-2">
                <button type="button" class="btn btn-h btn-success px-3 mb-3" @click="CHANGE_PASSWORD()">
                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>Enviar contraseña nueva</span>
                </button>
                <small v-if="password">Contraseña enviada: {{ password }}</small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'errors'],
    data(){
        return{
            type_current: false,
            type_new: false,
            type_new_confirm: false,
            options: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            states: [
                { value: 0, text: 'Inactivo' },
                { value: 1, text: 'Activo' }
            ],
            count: 0,
            id: this.$route.params.id,
            password: ''
        }
    },
    methods: {
        CHANGE_PASSWORD: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/change/password/' + vue.id, method: 'GET' })
                    .then((resp) => {
                        vue.password = resp.data.password
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if(err.response.status === 422){
                            vue.errors = err.response.data
                        }else if(err.response.status === 402 || err.response.status === 404){
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }else{
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>